module.exports = __webpack_public_path__ + "1_0_62/img/close.adf0a991.svg";